import { preventDefault } from "@grrr/utils";

export const shareCalendarFoldout = function (el, evt) {
    preventDefault(evt);
    if (document.querySelector(".share__calendar")) {
        if (
            document
                .querySelector(".share__calendar")
                .classList.contains("share__calendar--in")
        ) {
            document
                .querySelector(".share__calendar")
                .classList.remove("share__calendar--in");
        } else {
            document
                .querySelector(".share__calendar")
                .classList.add("share__calendar--in");
        }
    }
};
